import React from 'react';
import './ServicesSection.css';

const ServiceSection = ({ id, title }) => {
  return (
    <div id={id} className="services-section">   
      {/**
       * 
       <div className="services-header">
        <img
            src="images/angebot.png"
            alt="Decorative"
        />
      </div>
       */}
      

      <div class="card-container">
        <div class="card">
          <img src="/images/services/staudenbeet_gelb.png" alt="Lawn Care"/>
          <div class="card-content">
            <h3>Staudenbeete</h3>
            <p>Beratung, Planung, Erstellung und Pflege</p>
          </div>
        </div>
      
        <div class="card">
          <img src="/images/services/heckenschere_gelb.png" alt=""/>
          <div class="card-content">
            <h3>Heckenschnitt</h3>
            <p>von Sträuchern bis zu Kleingehölzen</p>
          </div>
        </div>

        <div class="card">
          <img src="/images/services/gartenpflege_gelb.png" alt=""/>
          <div class="card-content">
            <h3>Pflege</h3>
            <p>von Sträuchern bis zu Kleingehölzen</p>
          </div>
        </div>
      

        <div class="card">
          <img src="/images/services/consultation_gelb.png" alt=""/>
          <div class="card-content">
            <h3>Beratung</h3>
            <p>für Pflanzenstärkung und/oder Gesundung</p>
          </div>
        </div>

        <div class="card">
          <img src="/images/services/haecksler_gelb.png" alt=""/>
          <div class="card-content">
            <h3>Gartenhäcksler</h3>
            <p>benötigt Starkstromanschluss</p>
          </div>
        </div>

        <div class="card">
          <img class="emfischer-img" src="/images/services/emfischer_gelb.png" alt=""/>
          <div class="card-content">
            <h3>Offizieller Partner</h3>
            <p>Mikroorganismen</p>
          </div>
        </div>
      </div>
      
    </div>
    
  );
};

export default ServiceSection;

/*
,Beratung, Planung, Erstellung und Pflege von Staudenbeeten
,Heckenschnitt
,Pflege von Sträuchern und Kleingehölzen
,Beratung bei Pflanzenstärkung und/oder Gesundung


,Auf Wunsch auch mit Gartenhäcksler möglich
Unterstützt den Nährstoffkreislauf und fördert somit Pflanzen und Bodenleben.
,Ebenso für den Kompost geeignet
,Erfordert einen Starkstromanschluss
, Bei Interesse gerne melden:
info-natuerlik@gmx.de
oder Whatsapp
*/